// extracted by mini-css-extract-plugin
module.exports = {"noEnoughInfoText":"ExpensesChart_noEnoughInfoText__1KX7K","chartContainer":"ExpensesChart_chartContainer__1xigO","centerAlign":"ExpensesChart_centerAlign__YqdA0"};